/* icon-stack.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./icon-stack.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Children } from 'react';
var styles = {
  list: "_1e0c1txw _19121cl4 _6rthze3t _1pfhze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
  item: "_6rthze3t _1pfhze3t _ahbqze3t"
};
var unboundStyles = {
  list: "_2mzuglyw _12l2t94y",
  item: "_2rko12b0 _bfhkvuon _16qsz8ju _1e0c116y _12l21n1a"
};
var DEFAULT_MAX_STACK_SIZE = 3;
export function IconStack(_ref) {
  var children = _ref.children,
    maxStackSize = _ref.maxStackSize,
    testId = _ref.testId;
  maxStackSize = maxStackSize !== null && maxStackSize !== void 0 ? maxStackSize : DEFAULT_MAX_STACK_SIZE;
  return /*#__PURE__*/React.createElement("ul", {
    "aria-hidden": true,
    "data-testid": testId,
    className: ax([styles.list, unboundStyles.list])
  }, Children.map(children, function (child, index) {
    return child && /*#__PURE__*/React.createElement("li", {
      style: {
        zIndex: maxStackSize - index
      },
      className: ax([styles.item, unboundStyles.item])
    }, child);
  }));
}